/**
 * Lightbox Download
 * Keeps the core image lightbox open when its download button is clicked.
 */

function initLightboxDownload() {
  const link = document.querySelector(".wp-lightbox-overlay .wp-lightbox-download");
  if (!link) return;

  link.addEventListener("click", (e) => {
    e.stopPropagation();
  });
}

export default initLightboxDownload;
